import { HandlerWithResult, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { ProductFilters } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";
import { ResetPage, RemoveAttributeValueFilters, chain } from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters"


type HandlerType = HandlerWithResult<ProductFilters, ProductFilters>;

export const ResetPageCustom: HandlerType = props => {
    if (
        props.parameter.pageSize ||
        props.parameter.sort ||
        props.parameter.pageCategoryId ||
        props.parameter.categoryId ||
        props.parameter.searchWithinQueries?.length ||
        props.parameter.brandIds?.length ||
        props.parameter.productLineIds?.length ||
        props.parameter.priceFilters?.length ||
        props.parameter.attributes?.length
    ) {
        props.result.page = undefined;
    }
};

export const RemoveAttributeValueFiltersCustom: HandlerType = props => {
    props.result.attributes = props.result.attributes?.filter(
        x => !props.parameter.attributes?.find(y => y === x),
    );
    if (props.result.attributes?.length === 0) {
        props.result.attributes = undefined;
    }
};

replaceInChain(chain, ResetPage, ResetPageCustom);
replaceInChain(chain, RemoveAttributeValueFilters, RemoveAttributeValueFiltersCustom);